import styled from 'styled-components'

export const RightPanelWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
`

export const CartHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 20px 24px 8px;
  flex-shrink: 0;

  @media (max-width: 1600px) {
    padding: 16px 24px 4px;
  }

  h2 {
    margin: 0;
    font-size: 1.375rem;
    font-weight: 700;
    letter-spacing: -0.01em;
    color: ${({ theme }) => theme.colors.global};
  }
`

export const CartItemCount = styled.span`
  display: inline-flex;
  align-items: center;
  height: 28px;
  padding: 0 12px;
  border-radius: 999px;
  background: ${({ theme }) => theme.colors.primary}14;
  color: ${({ theme }) => theme.colors.primaryText || theme.colors.primary};
  font-size: 0.85rem;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
`

const fadeMask = ({ $fadeTop, $fadeBottom }) => {
  const top = $fadeTop ? 'transparent 0, #000 24px' : '#000 0'
  const bottom = $fadeBottom ? '#000 calc(100% - 32px), transparent 100%' : '#000 100%'
  return `linear-gradient(to bottom, ${top}, ${bottom})`
}

export const CartList = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior: contain;
  padding: 0 24px;
  display: flex;
  flex-direction: column;
  -webkit-mask-image: ${fadeMask};
  mask-image: ${fadeMask};

  &::-webkit-scrollbar {
    width: 4px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: var(--color-line);
    border-radius: 2px;
  }
`

export const CartEmpty = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 32px 24px 64px;
  text-align: center;
  color: var(--color-muted);
  font-size: 1.05rem;
  line-height: 1.45;

  p {
    margin: 0;
    max-width: 300px;
  }
`

export const CartEmptyIcon = styled.div`
  width: 96px;
  height: 96px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => theme.colors.primary}12;
  color: ${({ theme }) => theme.colors.primaryText || theme.colors.primary};

  svg {
    width: 44px;
    height: 44px;
  }
`
